import { ActionReducer } from '@ngrx/store';
import { AppState } from './app-state.model';
import { storeLogger } from 'ngrx-store-logger';

export function logger(reducer: ActionReducer<AppState>) {
	return storeLogger()(reducer);
}
